/**
 * Helper for quotations page and functionalities
 */

/**
 * Returns the quotation type from dataOptionId
 * @param {String} dataOptionId 
 *  Sample
 *      'accumulatoreProposto-basic'
 * @return {String}
 *  ['basic'|'plus']
 *  Sample
 *      'basic'
 */
const quotationTypeFromOptionId = (dataOptionId) => {
    return dataOptionId.split('-')[1];
};

/**
* Returns the quotation type from dataOptionId
* @param {String} dataOptionId 
*  Sample
*      'accumulatoreProposto-basic'
* @return {String}
*  Sample
*      'accumulatoreProposto'
*/
const optionNameFromOptionId = (dataOptionId) => {
   return dataOptionId.split('-')[0];
};

/**
 * Returns the 'option' data path related to the dataOptionId option
 * The data path is the acces key to the data value in the PageQuotations this.state.data
 * @param {String}
 *  Sample
 *      'accumulatoreProposto-basic'
 * @return {String}
 *  Sample
 *      'accumulatoreProposto.options.basic'
 */
const dataOptionPathFromOptionId = (dataOptionId) => {
    const tmp = dataOptionId.split('-');
    return tmp[0] + '.options.' + tmp[1];
};

/**
 * In Configurator Battery, the 'basic' and 'plus' quotation types have been 'renamed' to 'kwh5' and 'kwh10'
 * This function keeps the quotationType and and kwh values in synch
 * @param {String} kw
 *  ['kwh5'|'kwh10']
 * @return {String}
 *  ['basic'|'plus']
 */
const kwhToQuotationType = kw => {
    const map = {
        kwh5: 'basic',
        kwh10: 'plus'
    };
    return map[kw];
};

export {
    quotationTypeFromOptionId,
    optionNameFromOptionId,
    dataOptionPathFromOptionId,
    kwhToQuotationType
}